// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"73daa4ba","247":"3c86c2ae","284":"0b8d88b9","627":"d1e71bfd","768":"2ca93c5e","834":"b5a729e2","867":"b656f2eb","923":"43a31b91","938":"00321075"}[chunkId] + ".chunk.js";
};